import React from 'react';
import { FaStar } from 'react-icons/fa';

const StarRating = ({ rating, onRate, totalStars = 5, disabled = false, size = 24 }) => {
  const [hover, setHover] = React.useState(null);

  return (
    <div className="flex items-center gap-1">
      {[...Array(totalStars)].map((_, index) => {
        const starValue = index + 1;
        const isFilled = (hover !== null ? hover : rating) >= starValue;
        return (
          <FaStar
            key={index}
            size={size}
            className={`transition-colors ${
              isFilled ? 'text-yellow-400' : 'text-gray-300'
            } ${disabled ? 'cursor-default' : 'cursor-pointer hover:scale-110'}`}
            onClick={() => !disabled && onRate(starValue)}
            onMouseEnter={() => !disabled && setHover(starValue)}
            onMouseLeave={() => !disabled && setHover(null)}
          />
        );
      })}
    </div>
  );
};

export default StarRating;